import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';

type Option<T extends string> = { value: T; label: string };

type Props<T extends string> = {
  options: Option<T>[];
  value: T;
  onChange: (v: T) => void;
};

export function SegmentedToggle<T extends string>({
  options,
  value,
  onChange,
}: Props<T>): ReactNode {
  return (
    <div className="inline-flex rounded-lg bg-white/[0.04] p-0.5">
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={cn(
            'rounded-md px-3 py-1 text-[11px] font-medium transition-all duration-200',
            value === opt.value
              ? 'bg-white/[0.1] text-text-primary shadow-sm'
              : 'text-text-tertiary hover:text-text-secondary'
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
